import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { OrangeMenuComponent } from './components/orange-menu/orange-menu.component';
import { SoshMenuComponent } from './components/sosh-menu/sosh-menu.component';

@NgModule({
    declarations: [OrangeMenuComponent, SoshMenuComponent],
    imports: [CommonModule, BrowserModule, TranslateModule, RouterModule],
    exports: [OrangeMenuComponent, SoshMenuComponent],
})
export class MenuModule {}
